export const toSentenceCase = (str) => {
  if (!str) return str
  return str.trim().charAt(0).toUpperCase() + str.trim().slice(1).toLowerCase()
}

// Small words stay lowercase mid-title, the way a hymnal or a tracklist sets
// them — "Way Maker", not "Way MAKER", and "Days Of Elijah" would look like a
// typo. First and last word are always capitalized regardless.
const TITLE_CASE_MINOR = new Set([
  'a', 'an', 'and', 'as', 'at', 'but', 'by', 'for', 'from', 'in', 'into',
  'nor', 'of', 'on', 'onto', 'or', 'over', 'the', 'to', 'with',
])

export const toTitleCase = (str) => {
  if (!str) return str
  const words = str.trim().split(/\s+/)
  return words
    .map((word, i) => {
      const lower = word.toLowerCase()
      if (i > 0 && i < words.length - 1 && TITLE_CASE_MINOR.has(lower)) return lower
      return lower.charAt(0).toUpperCase() + lower.slice(1)
    })
    .join(' ')
}

/**
 * Seconds as m:ss. The one time format in the app — a clip length, a trim
 * handle, a position in a song are all the same reading.
 */
export const mmss = (s) => {
  const t = Math.max(0, Math.round(s || 0))
  return `${Math.floor(t / 60)}:${String(t % 60).padStart(2, '0')}`
}
